<div class="content-view">
    <div class="preview" (click)="onPreview()" [ngClass]="{'active': previewMode, 'hidden': !previewOn}">
        <mat-icon class="preview-icon">play_circle</mat-icon>
    </div>
    <app-screen></app-screen>
    <ng-container [dynamic]="view()"></ng-container>
</div>
